<template>
  <div class="app-loader" :style="styles">
    <span class="loader" :style="styles"/>
  </div>
</template>

<script>

export default {
  name: 'VAppLoader',
  props: {
    size: {
      type: String,
      default: '50px',
    }
  },
  computed: {
    styles() {
      return {
        width: !!this.size ? this.size : '',
        height: !!this.size ? this.size : '',
      };
    },
  }
};
</script>

<style lang="scss" scoped>
@import "VAppLoader";
</style>
